// TODO: rename this file and its import sites to `missingTranslation` / MISSING_TRANSLATION at
// the earliest convenience. The name no longer describes the value and misleads readers into
// thinking the fallback is arbitrary; it is deliberately loud so untranslated strings are caught
// in QA. Purely mechanical — 12 files, no behavior change.
const MISSING_TRANSLATION = '[Missing Translation]';

export default MISSING_TRANSLATION;
